import type { PostLoginTranslations } from './types';

export const editorTranslations = {
  'editor.navigation.label': { es: 'Editor', en: 'Editor' },
  'editor.button.newTask': { es: 'Nueva tarea', en: 'New task' },
  'editor.button.edit': { es: 'Editar', en: 'Edit' },
  'editor.button.cancel': { es: 'Cancelar', en: 'Cancel' },
  'editor.button.close': { es: 'Cerrar', en: 'Close' },
  'editor.button.retry': { es: 'Reintentar', en: 'Retry' },
  'editor.button.duplicate': { es: 'Duplicar', en: 'Duplicate' },
  'editor.button.duplicating': { es: 'Duplicando…', en: 'Duplicating…' },
  'editor.button.improveAi': { es: 'Mejorar con IA', en: 'Improve with AI' },
  'editor.button.createTask': { es: 'Crear tarea', en: 'Create task' },
  'editor.button.creating': { es: 'Creando…', en: 'Creating…' },
  'editor.button.saveChanges': { es: 'Guardar cambios', en: 'Save changes' },
  'editor.button.saving': { es: 'Guardando…', en: 'Saving…' },
  'editor.button.previous': { es: 'Anterior', en: 'Previous' },
  'editor.button.next': { es: 'Siguiente', en: 'Next' },
  'editor.filters.pillars.all': { es: 'Todos los pilares', en: 'All pillars' },
  'editor.filters.search.label': { es: 'Búsqueda', en: 'Search' },
  'editor.filters.search.mobileLabel': { es: 'Buscar tareas', en: 'Search tasks' },
  'editor.filters.search.placeholder': { es: 'Buscar por título', en: 'Search by title' },
  'editor.filters.pillar.label': { es: 'Pilar', en: 'Pillar' },
  'editor.filters.pillar.mobileLabel': { es: 'Pilares', en: 'Pillars' },
  'editor.filters.pillar.loading': { es: 'Cargando pilares…', en: 'Loading pillars…' },
  'editor.filters.pillar.retry': { es: 'Reintentar cargar pilares', en: 'Retry loading pillars' },
  'editor.onboarding.nudge': {
    es: 'Listo. Volvé al Dashboard para tu primer Daily Quest',
    en: 'Done. Go back to Dashboard for your first Daily Quest',
  },
  'editor.onboarding.banner.message': {
    es: 'Ya editaste tu primera tarea. Volvé al Dashboard para seguir con el onboarding o quedate editando si querés.',
    en: 'You edited your first task. Go back to Dashboard to continue onboarding, or keep editing if you want.',
  },
  'editor.onboarding.banner.cta': { es: 'Volver al Dashboard', en: 'Back to Dashboard' },
  'editor.empty.noTasks': {
    es: 'Todavía no tienes tareas. Usa el botón para comenzar cuando esté listo.',
    en: "You don't have tasks yet. Use the button to get started when you're ready.",
  },
  'editor.empty.noMatches': {
    es: 'No encontramos tareas con los filtros actuales. Ajusta la búsqueda para ver más resultados.',
    en: 'No tasks match the current filters. Adjust your search to see more results.',
  },
  'editor.empty.noVisibleTasks': { es: 'No encontramos tareas para mostrar.', en: 'No tasks to display.' },
  'editor.error.loadTasks.title': { es: 'No pudimos cargar tus tareas.', en: 'We could not load your tasks.' },
  'editor.field.pillar': { es: 'Pilar', en: 'Pillar' },
  'editor.field.trait': { es: 'Rasgo', en: 'Trait' },
  'editor.field.stat': { es: 'Stat', en: 'Stat' },
  'editor.field.difficulty': { es: 'Dificultad', en: 'Difficulty' },
  'editor.field.baseGp': { es: 'GP base', en: 'Base GP' },
  'editor.field.updatedAt': { es: 'Actualizada', en: 'Updated' },
  'editor.field.noPillar': { es: 'Sin pilar', en: 'No pillar' },
  'editor.field.noDifficulty': { es: 'Sin dificultad', en: 'No difficulty' },
  'editor.field.status': { es: 'Estado', en: 'Status' },
  'editor.board.emptyPillar': { es: 'Sin tareas en este pilar.', en: 'No tasks in this pillar.' },
  'editor.task.actions.more': { es: 'Más acciones', en: 'More actions' },
  'editor.task.status.active': { es: 'Activa', en: 'Active' },
  'editor.task.status.inactive': { es: 'Inactiva', en: 'Inactive' },
  'editor.modal.delete.heading': { es: 'Confirmar eliminación', en: 'Confirm deletion' },
  'editor.modal.delete.title': { es: 'Eliminar tarea', en: 'Delete task' },
  'editor.modal.delete.thisTask': { es: 'esta tarea', en: 'this task' },
  'editor.modal.delete.message': {
    es: '¿Seguro que quieres eliminar {{title}}? Esta acción quitará la tarea de tu lista inmediatamente.',
    en: 'Are you sure you want to delete {{title}}? This action will remove the task from your list immediately.',
  },
  'editor.modal.delete.confirm': { es: 'Eliminar', en: 'Delete' },
  'editor.modal.delete.loading': { es: 'Eliminando…', en: 'Deleting…' },
  'editor.modal.create.badge': { es: 'Nueva tarea', en: 'New task' },
  'editor.modal.create.title': { es: 'Crear tarea personalizada', en: 'Create custom task' },
  'editor.modal.create.description': {
    es: 'Define el pilar y rasgo para desbloquear campos específicos de tu misión.',
    en: 'Set pillar and trait to unlock mission-specific fields.',
  },
  'editor.modal.create.step1': { es: 'Paso 1 · Pilar', en: 'Step 1 · Pillar' },
  'editor.modal.create.step2': { es: 'Paso 2 · Rasgo', en: 'Step 2 · Trait' },
  'editor.modal.create.step3': { es: 'Paso 3 · Stat', en: 'Step 3 · Stat' },
  'editor.modal.create.selectPillarLabel': { es: 'Selecciona un pilar', en: 'Select a pillar' },
  'editor.modal.create.selectPillarPlaceholder': { es: 'Selecciona un pilar…', en: 'Select a pillar…' },
  'editor.modal.create.selectTraitLabel': { es: 'Selecciona un rasgo', en: 'Select a trait' },
  'editor.modal.create.selectTraitPlaceholder': { es: 'Selecciona un rasgo…', en: 'Select a trait…' },
  'editor.modal.create.selectPillarFirst': { es: 'Selecciona primero un pilar', en: 'Select a pillar first' },
  'editor.modal.create.selectStatLabel': { es: 'Selecciona un stat (opcional)', en: 'Select a stat (optional)' },
  'editor.modal.create.selectStatPlaceholder': { es: 'Selecciona un stat…', en: 'Select a stat…' },
  'editor.modal.create.selectTraitFirst': { es: 'Selecciona primero un rasgo', en: 'Select a trait first' },
  'editor.modal.create.taskTitleLabel': { es: 'Título de la tarea', en: 'Task title' },
  'editor.modal.taskTitle.placeholder': { es: 'Ej. Entrenar 30 minutos', en: 'E.g. Train for 30 minutes' },
  'editor.modal.create.selectDifficultyPlaceholder': {
    es: 'Selecciona una dificultad…',
    en: 'Select a difficulty…',
  },
  'editor.modal.aiCreate.badge': { es: 'Nueva tarea', en: 'New Task' },
  'editor.modal.aiCreate.title': { es: 'Nueva tarea guiada', en: 'Guided new task' },
  'editor.modal.aiCreate.description': {
    es: 'Escribe tu intención y deja que la IA sugiera la mejor categoría.',
    en: 'Write your intent and let AI suggest the best category.',
  },
  'editor.modal.aiCreate.taskTitleLabel': {
    es: '¿Qué tarea querés sumar?',
    en: 'What task do you want to add?',
  },
  'editor.modal.aiCreate.taskTitlePlaceholder': {
    es: 'Ej. Caminar 30 minutos',
    en: 'E.g. Walk for 30 minutes',
  },
  'editor.modal.aiCreate.suggestButton': {
    es: 'Generar categoría',
    en: 'Generate category',
  },
  'editor.modal.aiCreate.analyzing': {
    es: 'Analizando tarea…',
    en: 'Analyzing task…',
  },
  'editor.modal.aiCreate.analyzingHint': {
    es: 'Revisando intención, contexto y patrón de hábito.',
    en: 'Reviewing intent, context, and habit pattern.',
  },
  'editor.modal.aiCreate.suggestedCategory': {
    es: 'Categoría generada',
    en: 'Generated category',
  },
  'editor.modal.aiCreate.retrySuggestion': {
    es: 'Reintentar sugerencia',
    en: 'Retry suggestion',
  },
  'editor.modal.aiCreate.manualCategory': {
    es: 'Elegir manualmente',
    en: 'Set manually',
  },
  'editor.modal.aiCreate.useAiSuggestion': {
    es: 'Usar sugerencia IA',
    en: 'Use AI suggestion',
  },
  'editor.modal.aiCreate.confirmButton': {
    es: 'Confirmar tarea',
    en: 'Confirm task',
  },
  'editor.modal.aiCreate.confirmationRequired': {
    es: 'Primero usa “Generar categoría”.',
    en: 'Please use “Generate category” first.',
  },
  'editor.modal.aiCreate.catalogFallback': {
    es: 'No hay catálogo suficiente para sugerir una categoría por ahora.',
    en: 'Catalog data is not enough to suggest a category right now.',
  },
  'editor.modal.aiCreate.noTraits': {
    es: 'No encontramos rasgos para el pilar sugerido.',
    en: 'No traits were found for the suggested pillar.',
  },
  'editor.modal.aiCreate.suggestionError': {
    es: 'No pudimos sugerir categoría. Intenta nuevamente.',
    en: 'Could not suggest a category. Please try again.',
  },
  'editor.modal.edit.badge': { es: 'Editar tarea', en: 'Edit task' },
  'editor.modal.edit.panelTitle': { es: 'Editar tarea', en: 'Edit task' },
  'editor.modal.edit.title': { es: 'Actualiza los detalles de tu tarea', en: 'Update your task details' },
  'editor.modal.edit.description': {
    es: 'Ajusta el título, dificultad y estado. Los campos de pilar y rasgo permanecen bloqueados.',
    en: 'Adjust title, difficulty, and status. Pillar and trait fields stay locked.',
  },
  'editor.modal.edit.context': { es: 'Contexto', en: 'Context' },
  'editor.modal.edit.lockedHint': {
    es: 'Estos campos no se pueden editar.',
    en: 'These fields cannot be edited.',
  },
  'editor.modal.edit.editableFields': { es: 'Campos editables', en: 'Editable fields' },
  'editor.modal.edit.noDifficultyAssigned': { es: 'Sin dificultad asignada', en: 'No assigned difficulty' },
  'editor.loading.pillars': { es: 'Cargando pilares…', en: 'Loading pillars…' },
  'editor.loading.traits': { es: 'Cargando rasgos…', en: 'Loading traits…' },
  'editor.loading.stats': { es: 'Cargando stats…', en: 'Loading stats…' },
  'editor.loading.difficulties': { es: 'Cargando dificultades…', en: 'Loading difficulties…' },
  'editor.error.pillars.load': { es: 'No se pudieron cargar los pilares.', en: 'Could not load pillars.' },
  'editor.error.traits.load': { es: 'No se pudieron cargar los rasgos.', en: 'Could not load traits.' },
  'editor.error.stats.load': { es: 'No se pudieron cargar los stats.', en: 'Could not load stats.' },
  'editor.error.difficulties.load': {
    es: 'No se pudieron cargar las dificultades.',
    en: 'Could not load difficulties.',
  },
  'editor.empty.noTraits': { es: 'Este pilar aún no tiene rasgos disponibles.', en: 'This pillar has no traits yet.' },
  'editor.empty.noStats': { es: 'Este rasgo aún no tiene stats asociados.', en: 'This trait has no associated stats yet.' },
  'editor.validation.selectPillar': { es: 'Selecciona un pilar para continuar.', en: 'Select a pillar to continue.' },
  'editor.validation.selectTrait': { es: 'Selecciona un rasgo para continuar.', en: 'Select a trait to continue.' },
  'editor.validation.titleRequired': { es: 'El título es obligatorio.', en: 'Title is required.' },
  'editor.validation.userNotFound': {
    es: 'No se pudo identificar tu usuario. Intenta más tarde.',
    en: 'Could not identify your user. Try again later.',
  },
  'editor.validation.taskNotFound': {
    es: 'No se encontró la tarea que deseas eliminar.',
    en: 'The task you want to delete was not found.',
  },
  'editor.validation.taskNotFoundEdit': {
    es: 'No se encontró la tarea que deseas editar.',
    en: 'The task you want to edit was not found.',
  },
  'editor.toast.create.success': { es: 'Tarea creada correctamente.', en: 'Task created successfully.' },
  'editor.toast.create.error': { es: 'No se pudo crear la tarea.', en: 'Could not create task.' },
  'editor.toast.update.success': { es: 'Tarea actualizada correctamente.', en: 'Task updated successfully.' },
  'editor.toast.update.error': { es: 'No se pudo actualizar la tarea.', en: 'Could not update task.' },
  'editor.toast.delete.success': { es: 'Tarea eliminada.', en: 'Task deleted.' },
  'editor.toast.delete.error': { es: 'No se pudo eliminar la tarea.', en: 'Could not delete task.' },
  'editor.toast.duplicate.success': { es: 'Tarea duplicada correctamente.', en: 'Task duplicated successfully.' },
  'editor.toast.duplicate.error': { es: 'No se pudo duplicar la tarea.', en: 'Could not duplicate task.' },
  'editor.toast.improve.comingSoon': {
    es: 'Pronto podrás mejorar tareas con IA desde aquí.',
    en: 'Soon you will be able to improve tasks with AI from here.',
  },
  'editor.toast.edit.firstQuestReady': {
    es: 'Cambios guardados. Ya podés hacer tu primer Daily Quest.',
    en: 'Changes saved. You can now do your first Daily Quest.',
  },
  'editor.toast.edit.saved': { es: 'Cambios guardados.', en: 'Changes saved.' },
  'editor.duplicate.copySuffix': { es: '(copia)', en: '(copy)' },
  'editor.duplicate.fallbackTitle': { es: 'Tarea duplicada', en: 'Duplicated task' },
} satisfies PostLoginTranslations;
